<template>
    <div class="banner-analytics td-text-center">
        <h4 class="summary-heading mt-2">Banner Analytics</h4>
        <div class="td-table-container">
            <table cellspacing="0" cellpadding="0" class="td-table">
                <thead>
                    <tr class="table-header">
                        <th>Date</th>
                        <th>Views</th>
                        <th>Clicks</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="table-row" v-for="(item, index) in analytics" :key="index">
                        <td><span class="show-mobile td-text-secondary">Date: </span>{{onlyMonth(item.time)}}</td>
                        <td><span class="show-mobile td-text-secondary">Views: </span><span v-if="item.facts.bv">{{item.facts.bv}}</span></td>
                        <td><span class="show-mobile td-text-secondary">Clicks: </span><span v-if="item.facts.bc">{{item.facts.bc}}</span></td>
                    </tr>
                </tbody>
            </table>
        </div>

    </div>
</template>

<script>
    import script from './BannerAnalytics';
    export default script;</script>

<style lang="less">
    @import "./BannerAnalytics.less";
</style>